{
  "*": {
    "shadow": {
      "type": "string",
      "title": "Shadow",
      "format": "shadow",
      "group": "Styles",
      "default": "0 4px 12px 0 #0000001f",
      "seed": false
    },
    "border": {
      "type": "border",
      "title": "Border",
      "group": "Styles"
    },
    "border-radius": {
      "type": "string",
      "controls": "quad",
      "title": "Corner Radius",
      "units": [
        "px"
      ],
      "group": "Styles",
      "responsive": true,
      "min": 0
    },
    "top": {
      "type": "string",
      "title": "Top",
      "controls": "slider",
      "units": [
        "px"
      ],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position"
    },
    "left": {
      "type": "string",
      "title": "Left",
      "controls": "slider",
      "units": [
        "px"
      ],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position"
    },
    "padding": {
      "type": "string",
      "title": "Padding",
      "controls": "quad",
      "units": [
        "px"
      ],
      "group": "Spacing",
      "responsive": true,
      "removable": false
    }
  },
  "text_block": {
    "font-family": {
      "type": "string",
      "format": "font",
      "title": "Font Family",
      "group": "Formatting"
    },
    "align": {
      "type": "string",
      "title": "Align",
      "enum": [
        "left",
        "center",
        "right"
      ],
      "default": "left",
      "seed": false,
      "responsive": true,
      "group": "Formatting"
    },
    "color": {
      "type": "string",
      "format": "color",
      "title": "Color",
      "group": "Formatting"
    },
    "line-height": {
      "type": "string",
      "title": "Line Height",
      "controls": "slider",
      "units": [
        "rem"
      ],
      "min": 0,
      "max": 5,
      "step": 0.1,
      "default": "1.6rem",
      "group": "Formatting"
    }
  },
  "hero_block": {
    "height": {
      "type": "string",
      "title": "Height",
      "units": [
        "px",
        "%"
      ],
      "responsive": true,
      "controls": "slider",
      "allow_auto": true,
      "min": 20,
      "max": 1000,
      "step": 10,
      "default": "200px",
      "group": "Styles",
      "removable": false
    },
    "object-fit": {
      "type": "string",
      "title": "Fit",
      "enum": [
        "cover",
        "contain"
      ],
      "default": "cover",
      "group": "Styles",
      "removable": false
    },
    "width": {
      "type": "string",
      "title": "Width (Desktop)",
      "enum": [
        "contain",
        "full"
      ],
      "default": "contain",
      "group": "Styles",
      "removable": false
    },
    "object-position": {
      "type": "string",
      "title": "Image Align",
      "controls": "positioner",
      "responsive": true,
      "default": "center center",
      "seed": false,
      "group": "Styles"
    },
    "opacity": {
      "type": "string",
      "title": "Opacity",
      "controls": "slider",
      "units": [],
      "min": 0,
      "max": 1,
      "step": 0.1,
      "default": "1",
      "responsive": true,
      "seed": false,
      "group": "Styles"
    },
    "background-color": {
      "type": "string",
      "title": "Image Background",
      "format": "color",
      "responsive": true,
      "seed": false,
      "group": "Styles"
    }
  },
  "button_block": {
    "display": {
      "type": "string",
      "title": "Display",
      "enum": [
        "block",
        "inline"
      ],
      "default": "block",
      "group": "Styles",
      "responsive": true
    },
    "align": {
      "type": "string",
      "title": "Align",
      "enum": [
        "left",
        "center",
        "right"
      ],
      "default": "left",
      "group": "Styles",
      "responsive": true
    }
  },
  "layout_block": {
    "max-width": {
      "type": "string",
      "title": "Max Width",
      "units": [
        "%",
        "px"
      ],
      "controls": "slider",
      "allow_auto": true,
      "min": 100,
      "max": 2000,
      "step": 1,
      "default": "auto",
      "group": "Display",
      "removable": false
    }
  }
}
